import type { CatalogRow } from './geminiCatalogFilters.ts';

type CatalogClient = { functions: { invoke: (name: string, options: { body: Record<string, unknown> }) => Promise<{ data: any; error: any }> } };
/** Use the existing activation gate: saved audio/duration checks and an atomic
 * compare-and-set on the complete current actor properties stay server-side. */
export async function setCatalogVoiceActive(client: CatalogClient, voice: CatalogRow, active: boolean): Promise<void> {
  const result = await client.functions.invoke('gemini-catalog', { body: {
    action: 'update', voice_id: voice.id, display_name: voice.display_name, is_active: active,
    expected: { display_name: voice.display_name, is_active: voice.is_active, narrator: voice.is_narrator === true, metadata: voice.provider_metadata },
    trait_updates: {},
  } });
  let detail = result.data;
  if (result.error?.context instanceof Response) { try { detail = await result.error.context.json(); } catch { /* use the safe fallback */ } }
  if (result.error || detail?.saved !== true || detail?.voice_id !== voice.id) throw Error(detail?.error || 'Unable to update voice activation. Refresh and try again.');
}

export function catalogScanTimestamp(value: unknown): string | null {
  const status = value as { last_scanned_at?: unknown } | null;
  if (!status || !Object.hasOwn(status, 'last_scanned_at')) throw Error('Invalid scan status');
  if (status.last_scanned_at === null) return null;
  if (typeof status.last_scanned_at !== 'string' || !Number.isFinite(Date.parse(status.last_scanned_at))) throw Error('Invalid scan timestamp');
  return status.last_scanned_at;
}
